// export const SERVICE_URL = `http://127.0.0.1:3000/`;
export const SERVICE_URL = `https://ks5jby85id.execute-api.us-east-2.amazonaws.com/Prod/`;

export const STATUS_CODE = {
  SUCCESS: "SUCCESS",
};

export const RTypeEnum = [
  { name: "Loading Time", value: 0 },
  { name: "Offloading Time", value: 1 },
  { name: "Loading Wait Time", value: 2 },
  { name: "Offloading Wait Time", value: 3 },
  { name: "Time After Loading", value: 4 },
  { name: "Time After Offloading", value: 5 },
  { name: "Total Trip Time", value: 6 },
  { name: "Loading Cycle", value: 7 },
  { name: "Offloading Cycle", value: 8 },
];

export const EventType = [
  { name: "Accepted", value: 0 },
  { name: "Started", value: 1 },
  { name: "Arrived PickUp Point", value: 2 },
  { name: "Loading Started", value: 3 },
  { name: "Loading Completed", value: 4 },
  { name: "Journey Started", value: 5 },
  { name: "Reached Delivery Point", value: 6 },
  { name: "Offloading Started", value: 7 },
  { name: "Offloading Completed", value: 8 },
  { name: "Return Journey Started", value: 9 },
  { name: "Returned to Base", value: 10 },
  { name: "Finished", value: 11 },
];
//AI Event Type
export const AIConsignmentDeliveryEvents = [
  { name: "Started", value: 1 },
  { name: "Arrived at Pickup Point", value: 20 },
  { name: "Delivery Journey Started", value: 13 },
  { name: "Reached Delivery Point", value: 17 },
  { name: "Return Journey Started", value: 18 },
  { name: "Returned To Base", value: 14 },
  { name: "Finished", value: 16 },
];
// Nexus - TrackRight AI trip events, for Event Actions (module 4). Values match
// the AI delivery events.
export const NexusConsignmentEvents = [
  { name: "Arrived at Pickup Point", value: 20 },
  { name: "Delivery Journey Started", value: 13 },
  { name: "Reached Delivery Point", value: 17 },
  { name: "Return Journey Started", value: 18 },
  { name: "Returned To Base", value: 14 },
  { name: "Finished", value: 16 },
];
export const AIConsignmentCollectionEvents = [
  { name: "Started", value: 1 },
  { name: "Pickup Journey Started", value: 13 },
  { name: "Arrived Pickup Point", value: 17 },
  { name: "Delivery journey Started", value: 18 },
  { name: "Reached Delivery point", value: 14 },
  { name: "Finished", value: 16 },
];
export const AIConsignmentCombinedEvents = [
  { name: "Started", value: 1 },
  { name: "Arrived at Pickup Point", value: 20 },
  { name: "Pickup Journey Started", value: 13 },
  { name: "Delivery Journey Started", value: 13 },
  { name: "Reached Delivery Point", value: 17 },
  { name: "Return Journey Started", value: 18 },
  { name: "Returned To Base", value: 14 },
  { name: "Finished", value: 16 },
];
export const ActiontypeEnum = [
  { name: "SMS", value: 0 },
  { name: "EMAIL", value: 1 },
];

export const OfficeType = [
  { name: "DepoOffice", value: 1 },
  { name: "HeadOffice", value: 2 },
];

export const Reciepenttype = [
  { name: "Consignor", value: "C" },
  { name: "Transporter", value: "S" },
  { name: "Consignee", value: "Co" },
];
export const statusEnum = [
  { name: "InActive", value: 2 },
  { name: "Active", value: 1 },
];

export const FuelTypeEnum = [
  { name: "Diesel", value: 0 },
  { name: "Petrol", value: 1 },
];

export const Transmission = [
  { name: "Manual", value: 0 },
  { name: "Automatic", value: 1 },
];

export const chargetype = [
  { name: "TruckWise", value: 1 },
  { name: "DailyRate", value: 2 },
  { name: "PerTrip", value: 3 },
  { name: "PerCBM", value: 4 },
  { name: "PerKG", value: 5 },
  { name: "None", value: 6 },
  { name: "PerKM", value: 7 },
];

export const priorityType = [
  { name: "Normal", value: 1 },
  { name: "High", value: 2 },
];

export const AttechmentType = [
  { value: 0, name: "PDF" },
  { value: 1, name: "Document" },
  { value: 2, name: "Image" },
];

export const TripStatusEnum = [
  { label: "Assigned", value: 0 },
  { label: "Accepted", value: 1 },
  { label: "Rejected", value: 2 },
  { label: "In Progress", value: 3 },
  { label: "Completed", value: 4 },
  { label: "Reassigned", value: 5 },
];
//AI TripstatusEnum
export const AITripStatusEnum = [
  { label: "Assigned", value: 0 },
  { label: "In-Progress", value: 3 },
  { label: "Completed", value: 4 },
];
export const TripStatusForCustom = [
  { label: "Unassigned", value: null },
  { label: "In Progress", value: 3 },
  { label: "Completed", value: 4 },
];

export const BreakTypeEnum = [
  { name: "Breakdown", value: 0 },
  { name: "Meals", value: 1 },
  { name: "Other", value: 2 },
  { name: "Rest", value: 3 },
  { name: "All", value: 4 },
];

export const TripTypeEnum = [
  { name: "Local", value: 1 },
  { name: "Safari", value: 2 },
];

export const PanTripTypeEnum = [
  { name: "Local", value: 1 },
  { name: "Transit", value: 2 },
];

export const widgets = [
  { name: "Trips", value: 0 },
  { name: "Consignments Created vs Delivered", value: 1 },
  { name: "Delivery Time", value: 2 },
  { name: "Clients", value: 3 },
  { name: "Loading Time", value: 4 },
  { name: "Loading Wait Time", value: 5 },
  { name: "Offloading Time", value: 6 },
  { name: "Offloading wait Time", value: 7 },
  { name: "Trips per Vehicle", value: 8 },
  { name: "Fuel per vehicle", value: 9 },
  { name: "Distance per Vehicle", value: 10 },
  { name: "Vehicle Mileage", value: 11 },
  { name: "Loading Cycle", value: 12 },
  { name: "Offloading Cycle", value: 13 },
  { name: "Time After Loading", value: 14 },
  { name: "Time After Offloading", value: 15 },
  { name: "Carbon Footprint", value: 16 },
  { name: "Delivery Rate", value: 17 },
  { name: "Vehicle Utilization", value: 18 },
];

export const CargoWidgets = [
  { name: "Trips", value: 0 },
  { name: "Consignments Created vs Delivered", value: 1 },
  { name: "Delivery Time", value: 2 },
  { name: "Clients", value: 3 },
  { name: "Loading Time", value: 4 },
  { name: "Loading Wait Time", value: 5 },
  { name: "Offloading Time", value: 6 },
  { name: "Offloading wait Time", value: 7 },
  { name: "Trips per Vehicle", value: 8 },
  { name: "Fuel per vehicle", value: 9 },
  { name: "Distance per Vehicle", value: 10 },
  { name: "Vehicle Mileage", value: 11 },
  { name: "Loading Cycle", value: 12 },
  { name: "Offloading Cycle", value: 13 },
  { name: "Time After Loading", value: 14 },
  { name: "Time After Offloading", value: 15 },
  { name: "Carbon Footprint", value: 16 },
  { name: "Delivery Rate", value: 17 },
  { name: "Vehicle Utilization", value: 18 },
  { name: "Live Telematics Distance", value: 19 },
];

export const WidgetsAi = [
  { name: "Trips", value: 0 },
  { name: "Consignments Crreeated vs Delivered", value: 1 },
  { name: "Delivery Time", value: 2 },
  { name: "Clients", value: 3 },
  // { name: "Loading Time", value: 4 },
  // { name: "Loading Wait Time", value: 5 },
  // { name: "Offloading Time", value: 6 },
  // { name: "Offloading wait Time", value: 7 },
  { name: "Trips per Vehicle", value: 8 },
  { name: "Fuel per vehicle", value: 9 },
  { name: "Distance per Vehicle", value: 10 },
  { name: "Vehicle Mileage", value: 11 },
  { name: "Loading Cycle", value: 12 },
  { name: "Offloading Cycle", value: 13 },
  // { name: "Time After Loading", value: 14 },
  // { name: "Time After Offloading", value: 15 },
  { name: "Carbon Footprint", value: 16 },
  { name: "Delivery Rate", value: 17 },
  { name: "Vehicle Utilization", value: 18 },
  { name: "Live Telematics Distance", value: 19 },
  { name: "Fuel Expected", value: 20 },
  { name: "Mileage - Expected", value: 21 },
  { name: "Empty KMs", value: 22 },
];

export const FieldTypeEnum = [
  { name: "CheckBox", value: 3 },
  { name: "TextBox", value: 2 },
  { name: "DropDown", value: 1 },
];
//trackright AI
export const dispatchtype = [
  { name: "Regular", value: 1 },
  { name: "Planned", value: 2 },
];
export const shipmentType = [
  { name: "Delivery", value: 1 },
  { name: "Collection", value: 2 },
];
export const finishedtype = [
  { name: "Reached Delivery Point", value: 1 },
  { name: "Returned to starting point", value: 2 },
];
//Shipment Type
export const ShipmentType = [
  { name: "Import", value: 1 },
  { name: "Export", value: 2 },
];

export const DispatchType = [
  { name: "Regular Dispatch", value: "0" },
  { name: "Planned Dispatch", value: "1" },
];
//
export const FinishType = [
  { name: "Arrived at Destination", value: 1 },
  { name: "Unlocked within Destination", value: 2 },
  { name: "Return to the starting point", value: 5 },
  { name: "Leave Destination", value: 0 },
];

export const NexusFinishType = [
  { name: "Return to the starting point", value: 5 },
  { name: "Arrived at Destination", value: 1 },
  { name: "Leave Destination", value: 0 },
];
export const CargoFinishType = [
  { name: "Unlocked within Destination", value: 2 },
  { name: "Return to the starting point", value: 5 },
  { name: "Leave Destination", value: 0 },
];

export const LockStatus = [
  { name: "All", value: "" },
  { name: "Locked", value: 0 },
  { name: "Unlocked", value: 1 },
];

export const TripStatus = [
  { name: "Completed", value: 3 },
  { name: "In Progress", value: 2 },
  { name: "Loaded", value: 1 },
];

export const CustomTagsEnum = [
  { label: "CODE", value: "CONSIGNID" },
  { label: "TRIPCODE", value: "TRIPID" },
  { label: "PICKUPDATETIME", value: "PICKUPDATETIME" },
  { label: "DELIVERYDATETIME", value: "DELIVERYDATETIME" },
  { label: "PICKUPLOC", value: "PICKUPLOC" },
  { label: "DELIVERYLOC", value: "DELIVERYLOC" },
  { label: "DRIVERNAME", value: "DRIVERNAME" },
  { label: "DRIVERPHONE", value: "DRIVERPHONE" },
  { label: "CUSTOMERNAME", value: "CUSTOMERNAME" },
  { label: "CUSTOMERPHONE", value: "CUSTOMERPHONE" },
  { label: "CUSTOMERADDRESS", value: "CUSTOMERADDRESS" },
  { label: "SHIPPERNAME", value: "SHIPPERNAME" },
  { label: "SHIPPERPHONE", value: "SHIPPERPHONE" },
  { label: "SHIPPERADDRESS", value: "SHIPPERADDRESS" },
  { label: "CONSIGNEENAME", value: "CONSIGNEENAME" },
  { label: "CONSIGNEEPHONE", value: "CONSIGNEEPHONE" },
  { label: "CONSIGNEEADDRESS", value: "CONSIGNEEADDRESS" },
  { label: "EVENTNAME", value: "EVENTNAME" },
  { label: "EVENTVALUE", value: "EVENTVALUE" },
  { label: "EVENTTIME", value: "EVENTTIME" },
  { label: "TRACKINGLINK", value: "TRACKINGLINK" },
  { label: "VEHICLENO", value: "VEHICLENO" },
  { label: "KPINAME", value: "KPINAME" },
  { label: "DATETIME", value: "DATETIME" },
  { label: "CONTACTPERSON", value: "CONTACTPERSON" },
  { label: "LOCATIONLINK", value: "LOCATIONLINK" },
  { label: "OTP", value: "OTP" },
  { label: "CONTAINERNO", value: "CONTAINERNO" },
];

export const ContainerConsignmentEvents = [
  { name: "Locked", value: 2 },
  { name: "Journey Started", value: 13 },
  { name: "Reached Delivery Point", value: 17 },
  { name: "Offloading Started", value: 19 },
  { name: "Offloading Completed", value: 11 },
  { name: "Return Journey Started", value: 18 },
  { name: "Returned To Base", value: 14 },
  { name: "Finished", value: 20 },
];

export const ContainerConsignmentExportEvents = [
  { name: "Locked", value: 2 },
  { name: "Journey Started", value: 13 },
  { name: "Arrived at Pickup Point", value: 17 },
  { name: "Loading Started", value: 19 },
  { name: "Loading Completed", value: 11 },
  { name: "Delivery Journey Started", value: 18 },
  { name: "Reached Delivery point", value: 14 },
  { name: "Finished", value: 20 },
];

export const ContainerConsignmentEventsForCustom = [
  { name: "Locked", value: 2 },
  { name: "Journey Started", value: 13 },
  { name: "Reached Delivery Point", value: 17 },
  { name: "Arrived Pickup Point", value: 17 },
  { name: "Loading Started", value: 19 },
  { name: "Loading Completed", value: 11 },
  { name: "Offloading Started", value: 19 },
  { name: "Offloading Completed", value: 11 },
  { name: "Return Journey Started", value: 18 },
  { name: "Returned To Base", value: 14 },
  { name: "Finished", value: 20 },
];
